const Actions = {
  REQUEST_ANSWER: 'request-answer',
}

export default Actions;
